module.exports = __webpack_public_path__ + "static/media/spookyswap.5ac59b93.gif";